module.exports = __webpack_public_path__ + "static/media/coursebg3.2c6e7dee.png";